@if (isLoading | async) {
  @if (!doNotShowLoadingSpinner()) {
    <div class="flex flex-wor space-x-2">
      <app-loading [classes]="['h-6', 'w-6']" [noWhitespace]="true" [hideText]="true"></app-loading>
    </div>
  }
} @else {
  <div class="flex flex-col space-y-1">
    @if (priceSubject | async; as price) {
      @if (price.priceOnRequest) {
        <span class="text-sm">{{ { key: 'priceOnRequest' } | i18n }}</span>
      } @else {
        @if (canBeSold()) {
          @if ((website.observeAuthenticated() | async) && !(cart.observeIsVatInclusive() | async)) {
            <div class="text-xs text-gray-400">
              {{ { key: 'msrp' } | i18n }}:
              {{ price.manufacturerSuggestedRetailPrice | bbitFormatPrice }}
            </div>
          }

          <div class="text-md" [class.text-red-600]="price.hasPromotion" [class.text-gray-900]="!price.hasPromotion">
            @if (cart.observeIsVatInclusive() | async) {
              <span class="font-bold">{{ price.priceInclVat | bbitFormatPrice }}</span>
              @if (price.hasPromotion) {
                <span class="text-xs">
                  &nbsp;{{ { key: 'insteadOf' } | i18n }}
                  {{ price.priceWithoutDiscountInclVat | bbitFormatPrice }}
                </span>
              }
            } @else {
              <span class="font-bold">{{ price.priceExclVat | bbitFormatPrice }}</span>
              @if (price.hasPromotion) {
                <span class="text-xs">
                  &nbsp;{{ { key: 'insteadOf' } | i18n }}
                  {{ price.priceWithoutDiscountExclVat | bbitFormatPrice }}
                </span>
              }
            }
          </div>
        } @else {
          <span class="text-sm">{{ { key: 'notPurchaseable' } | i18n }}</span>
        }
      }
    } @else {
      <span class="text-sm">{{ { key: 'notPurchaseable' } | i18n }}</span>
    }
  </div>
}
